var React = require('react');

function Neuter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144 256a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M284.37 144A144 144 0 1 0 112 316.41V468a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12V316.41A144 144 0 0 0 284.37 144zM144 256a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

Neuter.defaultProps = {"viewBox":"0 0 288 512","className":"icon"};

module.exports = Neuter;

Neuter.default = Neuter;
